"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phone = void 0;
const USA_1 = require("./USA");
exports.Phone = { USA: USA_1.USA };
//# sourceMappingURL=index.js.map